var logoZalo = "https://shopfront-cdn.tekoapis.com/static/98a2b9aacbb59a62.svg";

export { logoZalo as default };
